export default __webpack_public_path__ + "static/media/newlink.97e79d75.svg";